import React from 'react'
import gql from 'graphql-tag'
import moment from 'lib/localizedMoment'
import Query from 'components/shared/Query'
import Heading from 'components/shared/Heading'
import BookingAvailability from './BookingAvailability'

const getAvailableBookingsQuery = gql`
  query GetAvailableBookingsQuery(
    $webOrderId: ID!,
    $dates: [Date]!,
    $preferred_filter: AvailableBookingsFilter!,
    $non_preferred_filter: AvailableBookingsFilter!
  ) {
    webOrder(id: $webOrderId) {
      id
      serviceProviderAvailability(dates: $dates, filter: $preferred_filter) {
        date
        isAvailable
        unavailabilityReason
        serviceProvider {
          ...ServiceProviderProperties
        }
        pendingBookings {
          ...PendingBookingProperties
        }
      }
      availableBookings(dates: $dates, filter: $non_preferred_filter) {
        date
        isAvailable
        serviceProvider {
          ...ServiceProviderProperties
        }
        pendingBookings {
          ...PendingBookingProperties
        }
      }
    }
  }

  fragment PendingBookingProperties on PendingBooking {
    id
    startsAt
    endsAt
    bookingFee
  }

  fragment ServiceProviderProperties on ServiceProvider {
    id
    name
  }
`

const ShowResultsForDate = ({webOrder, date, reservedBooking, selectedBooking, setReservedBooking}) => {
  return (
    <Query
      inlineLoading
      inlineError
      notifyOnNetworkStatusChange
      fetchPolicy="network-only"
      query={getAvailableBookingsQuery}
      variables={{
        webOrderId: webOrder.id,
        dates: [moment(date).format('YYYY-MM-DD')],
        preferred_filter: 'preferred',
        non_preferred_filter: 'non_preferred',
      }}
    >
      {({getData}) => {
        const preferredResources = getData('webOrder.serviceProviderAvailability', [])
        const otherResources = getData('webOrder.availableBookings', [])

        return (
          <>
            {preferredResources.length > 0 && (
              <section className="preferred-resources">
                <Heading level={3}>Prefererte ressurser</Heading>
                {preferredResources.map((resource) => (
                  <BookingAvailability
                    key={resource.serviceProvider.id}
                    webOrder={webOrder}
                    resource={resource}
                    reservedBooking={reservedBooking}
                    selectedBooking={selectedBooking}
                    onSelect={(booking) => setReservedBooking(booking)}
                    onRemove={() => setReservedBooking(null)}
                  />
                ))}
              </section>
            )}

            <section className="other-resources">
              <Heading level={3}>Andre tilgjengelige ressurser</Heading>
              {otherResources.map((resource) => (
                <BookingAvailability
                  key={resource.serviceProvider.id}
                  webOrder={webOrder}
                  resource={resource}
                  reservedBooking={reservedBooking}
                  selectedBooking={selectedBooking}
                  onSelect={(booking) => setReservedBooking(booking)}
                  onRemove={() => setReservedBooking(null)}
                />
              ))}

              {otherResources.length === 0 && (
                <p>Fant ingen andre tilgjengelige ressurser for valgt dato.</p>
              )}
            </section>
          </>
        )
      }}
    </Query>
  )
}

export default ShowResultsForDate
